<template>
  <div class="vue-component-holder">
    <div class="row row-scheduler">
      <div class="col-lg-12">
        <div class="panel-body">
          <map-block
            v-if="def"
            :item="def"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MapBlock         from './../../widgets/MapBlock'
import DefinitionGetter from '../../../model/resource/getter/definitions-getter'

export default {
  name:       'map',
  components: { MapBlock },

  props: {
    menuField: {
      type:    Object,
      default: () => {
        return null
      }
    }
  },

  data () {
    return {
      page:        this.$route.params.page,
      idStructure: this.$route.params.idStructure,
      def:         null
    }
  },

  async created () {
    this.def = this.menuField

    await this.initDef()
  },

  methods: {
    async initDef () {
      let args    = {
            code:                   this.page,
            idtEntityStructureFrom: this.idStructure
          },
          success = (def) => {
            this.def = def.response.data[0]
          }

      return DefinitionGetter
        .getDataDefinition(
          args, success, (error) => {this.handleApiError(error) })
    }
  }
}

</script>

<style scoped>

.panel-body {
  height: calc(100vh - 80px);
}

</style>
